import React from 'react';
import { Button, Icon } from 'semantic-ui-react';

const MobileSlidesOverlay = ({ open, onClose, l }) => {
  if (!open || !window.thumbs) return null;

  const { slides, current_slide } = window.thumbs.state;
  if (!slides || slides.length === 0) return null;

  const handleSlideClick = (index) => {
    if (!window.thumbs.state.opening) {
      window.thumbs.sync();
      setTimeout(() => {
        window.thumbs.select(index);
        onClose();
      }, 1);
    }
  };

  return (
    <div style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 10000,
      backgroundColor: 'rgba(0, 0, 0, 0.85)',
      backdropFilter: 'blur(4px)',
      WebkitBackdropFilter: 'blur(4px)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '16px'
    }}>
      {/* Header */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        marginBottom: '16px'
      }}>
        <span style={{
          color: '#fff',
          fontWeight: 'bold',
          fontSize: '16px',
          textTransform: 'uppercase',
          letterSpacing: '1px'
        }}>
          {l.slides || 'Slides'}
        </span>
        <Button
          icon
          size='small'
          style={{
            background: 'rgba(255,255,255,0.15)',
            color: '#fff',
            margin: 0
          }}
          onClick={onClose}
        >
          <Icon name='close' />
        </Button>
      </div>

      {/* Slides grid */}
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '12px',
        justifyContent: 'center',
        overflowY: 'auto',
        maxWidth: '100%',
        width: '100%',
        WebkitOverflowScrolling: 'touch'
      }}>
        {slides.map((slide, index) => (
          <div
            key={index}
            onClick={() => handleSlideClick(index)}
            style={{
              width: 'calc(50% - 6px)',
              maxWidth: '160px',
              cursor: 'pointer',
              borderRadius: '8px',
              overflow: 'hidden',
              border: index === current_slide
                ? '3px solid coral'
                : '2px solid rgba(255,255,255,0.3)',
              backgroundColor: slide.bg_color || '#333',
              position: 'relative',
              transition: 'transform 0.15s ease, border-color 0.15s ease'
            }}
          >
            {/* Slide thumbnail */}
            {slide.base64_shapshot && (
              <img
                src={`data:image/png;base64,${slide.base64_shapshot}`}
                alt={`Slide ${index + 1}`}
                style={{
                  width: '100%',
                  display: 'block'
                }}
              />
            )}

            {/* Slide number badge */}
            <div style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              background: 'rgba(0,0,0,0.6)',
              color: '#fff',
              textAlign: 'center',
              fontSize: '12px',
              fontWeight: 'bold',
              padding: '4px 0'
            }}>
              {index + 1}
            </div>
          </div>
        ))}
      </div>

      {/* Add/Duplicate buttons */}
      <div style={{
        display: 'flex',
        gap: '8px',
        marginTop: '16px'
      }}>
        <Button
          icon='add'
          size='small'
          disabled={slides.length >= 3}
          style={{
            background: 'rgba(255,255,255,0.2)',
            color: '#fff'
          }}
          onClick={() => {
            window.thumbs.sync();
            setTimeout(() => {
              window.thumbs.add_slide();
              onClose();
            }, 1);
          }}
        />
        <Button
          icon='copy'
          size='small'
          disabled={slides.length >= 3}
          style={{
            background: 'rgba(255,255,255,0.2)',
            color: '#fff'
          }}
          onClick={() => {
            window.thumbs.duplicate_slide();
            onClose();
          }}
        />
      </div>
    </div>
  );
};

export default MobileSlidesOverlay;
